export enum PageContentType {
  // Home Page
  '/' = 'page',
  // Introduction Pages
  '/onboard/student' = 'page',
  // About Us Pages
  '/about-us' = 'page',
  // Tutor Page
  '/teach' = 'page',
  // Spaces Page
  '/spaces' = 'page',
  // Privacy Policy Page
  '/privacy-policy' = 'page',
  // Terms of Use Page
  '/terms-of-use' = 'page',
}

export enum SocialIconMap {
  twitter = 'twitter_icon',
  youtube = 'youtube_icon',
  linkedin = 'linkedin_icon',
  facebook = 'facebook_icon',
  instagram = 'instagram_icon',
  tiktok = 'tiktok_icon',
  snapchat = 'snapchat_icon',
  medium = 'medium_icon',
  mail = 'mail_icon',
}

export enum Roles {
  PARENT = '620d109a4d44ed3708f4604b',
  STUDENT = '66467ed8d619d5f47248842f',
}
